import React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import { Feather, Ionicons } from '@expo/vector-icons'
import styles from './LinealTabsStyles'
import { LinearGradient } from 'expo-linear-gradient'
import theme from '../../../theme'
import { constants } from 'buffer'
import { RoundedTabsTheme } from '../../../themeConstants'

export const LinealTabs = ({
    tabs,
    selectedIndex,
    colorSelected,
    color,
    onSelectedTab,
    gradient = false,
    status = 0,
    backgroundColor = ['white', 'white'],
}: {
    tabs: TabsModel[]
    selectedIndex: number
    colorSelected: string
    color: string
    onSelectedTab: (index: number) => void
    gradient?: boolean
    status?: number
    backgroundColor?: [string, string]
}) => {
    const Styles = styles({ length: tabs.length, gradient })
    const gradientColors: readonly [string, string] = gradient
        ? [theme.colors.linearGradientStart, theme.colors.linearGradientEnd]
        : backgroundColor
    const iconColor = gradient ? 'white' : colorSelected
    // console.log('STATUS', status)
    return (
        <LinearGradient
            colors={gradientColors}
            style={[Styles.container, { width: '100%' }]}
            start={{ x: 0, y: 0.5 }}
            end={{ x: 1, y: 0.5 }}
        >
            {tabs.map((tab, index) => {
                const isSelected = selectedIndex === tab.index
                return (
                    <TouchableOpacity
                        key={index}
                        onPress={() => onSelectedTab(tab.index)}
                        style={{ flex: 1 }}
                    >
                        <View style={[Styles.tab, { width: '100%' }]}>
                            <View style={{ flexDirection: 'row' }}>
                                <Text
                                    style={[
                                        Styles.text,
                                        {
                                            fontWeight: isSelected ? '600' : '600',
                                            color: isSelected
                                                ? colorSelected
                                                : color,
                                            fontSize: 14,
                                        },
                                    ]}
                                >
                                    {tab.name.toUpperCase()}
                                </Text>
                            </View>

                            <View
                                style={[
                                    Styles.divider,
                                    {
                                        backgroundColor: isSelected
                                            ? colorSelected
                                            : theme.colors.lightGray,
                                    },
                                ]}
                            />
                        </View>
                    </TouchableOpacity>
                )
            })}
        </LinearGradient>
    )
}

export const RoundedTabs = ({
    tabs,
    selectedIndex,
    colorLGStart,
    colorLGEnd,
    colorSelected,
    colorUnselected,
    onSelectedTab,
    containerStyle = null,
    textColorOn = null,
    textColorOff = null,
}: {
    tabs: TabsModel[]
    selectedIndex: number
    colorLGStart: string
    colorLGEnd: string
    colorSelected: string
    colorUnselected: string
    onSelectedTab: (index: number) => void
    containerStyle?: any
    textColorOn?: string
    textColorOff?: string
}) => {
    const Styles = styles({ length: tabs.length })
    const unselectedTextColor =
        colorUnselected == '#ffffff'
            ? theme.colors.colorPrimary
            : RoundedTabsTheme.unselectedTextColor
    return (
        <LinearGradient
            colors={[colorLGStart, colorLGEnd] as const}
            start={{ x: 0, y: 0.5 }}
            end={{ x: 1, y: 0.5 }}
        >
            <View style={[Styles.containerLinearGradient, containerStyle]}>
                <View
                    style={[
                        Styles.containerTabRounded,
                        { borderColor: colorSelected },
                    ]}
                >
                    {tabs.map((tab, index) => {
                        const isSelected = selectedIndex === tab.index
                        const isFirstTab = index === 0
                        const isLastTab = index === tabs.length - 1
                        return (
                            <TouchableOpacity
                                key={index}
                                onPress={() => onSelectedTab(tab.index)}
                                style={{ flex: 1 }}
                            >
                                <View
                                    style={[
                                        Styles.tabRounded,
                                        {
                                            borderTopStartRadius: isFirstTab
                                                ? 15
                                                : 0,
                                            borderBottomStartRadius: isFirstTab
                                                ? 15
                                                : 0,
                                            borderTopEndRadius: isLastTab ? 15 : 0,
                                            borderBottomEndRadius: isLastTab
                                                ? 15
                                                : 0,
                                            backgroundColor: isSelected
                                                ? colorSelected
                                                : colorUnselected,
                                        },
                                    ]}
                                >
                                    <Text
                                        style={[
                                            Styles.textRoundedTabUnselected,
                                            isSelected &&
                                                Styles.textRoundedTabSelected,
                                            isSelected && {
                                                color: unselectedTextColor,
                                            },
                                            textColorOn &&
                                                isSelected && { color: textColorOn },
                                            textColorOff &&
                                                !isSelected && {
                                                    color: textColorOff,
                                                },
                                        ]}
                                    >
                                        {tab.name.toUpperCase()}
                                    </Text>
                                </View>
                            </TouchableOpacity>
                        )
                    })}
                </View>
            </View>
        </LinearGradient>
    )
}

export interface TabsModel {
    name: string
    index: number
}
export const RoundedTabsGamification = ({
    tabs,
    selectedIndex,
    colorSelected,
    colorUnselected,
    color,
    onSelectedTab,
}: {
    tabs: TabsModel[]
    selectedIndex: number
    colorSelected: string
    colorUnselected: string
    color: string
    onSelectedTab: (index: number) => void
}) => {
    const Styles = styles({ length: tabs.length })
    return (
        <View style={Styles.containerNoMargin}>
            <View style={Styles.containerTabRounded}>
                {tabs.map((tab, index) => {
                    const isSelected = selectedIndex === tab.index
                    return (
                        <TouchableOpacity
                            key={index}
                            onPress={() => onSelectedTab(tab.index)}
                        >
                            <View
                                style={[
                                    Styles.tabRounded,
                                    {
                                        borderTopStartRadius: index === 0 ? 15 : 0,
                                        borderBottomStartRadius:
                                            index === 0 ? 15 : 0,
                                        borderTopEndRadius: index === 0 ? 0 : 15,
                                        borderBottomEndRadius: index === 0 ? 0 : 15,
                                        backgroundColor: isSelected
                                            ? colorSelected
                                            : colorUnselected,
                                    },
                                ]}
                            >
                                <Text
                                    style={
                                        isSelected
                                            ? Styles.textRoundedTabSelected
                                            : Styles.textRoundedTabUnselected
                                    }
                                >
                                    {tab.name.toUpperCase()}
                                </Text>
                            </View>
                        </TouchableOpacity>
                    )
                })}
            </View>
        </View>
    )
}

export const IconTabs = ({
    tabs,
    selectedIndex,
    colorSelected,
    colorUnselected,
    color,
    onSelectedTab,
}: {
    tabs: IconTabsModel[]
    selectedIndex: number
    colorSelected: string
    colorUnselected: string
    color: string
    onSelectedTab: (index: number) => void
}) => {
    const Styles = styles({ length: tabs.length })
    return (
        <View style={Styles.containerSections}>
            {tabs.map((tab, index) => {
                const isSelected = selectedIndex === tab.index
                return (
                    <TouchableOpacity
                        key={index}
                        style={{ flex: 1 }}
                        onPress={() => onSelectedTab(tab.index)}
                    >
                        <View style={Styles.section}>
                            <View style={Styles.sectionIcon}>
                                <Feather
                                    name={tab.icon}
                                    size={24}
                                    color={
                                        isSelected ? colorSelected : colorUnselected
                                    }
                                />
                            </View>
                            <View style={Styles.spacer}></View>
                            <Text
                                style={[
                                    Styles.sectionTitle,
                                    {
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        color: isSelected
                                            ? colorSelected
                                            : colorUnselected,
                                    },
                                ]}
                            >
                                {tab.name}
                            </Text>
                        </View>
                    </TouchableOpacity>
                )
            })}
        </View>
    )
}

export interface TabsModel {
    name: string
    index: number
}

export interface IconTabsModel {
    name: string
    icon: any
    index: number
}

// Ejemplo de donde lo llamas
//   setTabs([
//       {
//           name: 'Tab 1',
//           index: 0,
//       },
//       // {
//       //     name: 'Tab 2',
//       //     index: 1,
//       // },
//   ])
// Usar un switch para cambiar de tab
// const [selectedIndex, setSelectedIndex] = useState(0)
// En el onChange, setear el index
